<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    사업장 정보-->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('사업장 정보') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('작업내용') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>{{ $t('조사일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_5 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>{{ $t('작업자') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4"/>
        </div>

        <div>
          <div>{{ $t('수행일시') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>{{ $t('확인자') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3"/>
        </div>

        <div>
          <div>{{ $t('점검장소') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_6"/>
        </div>
        <div>
          <div>{{ $t('재해형태(필수)') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_7 }}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputB_7"
            :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    유해·위험요인 조사-->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('유해·위험요인 조사') }}</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>{{ $t('작업내용') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.inputC_1" rows="5" class="flex-1 w-full"/>
        </div>

        <div>
          <div>{{ $t('장소') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div>
          <div>{{ $t('위험정도') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
        <div>
          <div>{{ $t('사고유형') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_4" />
        </div>

        <div>
          <div>{{ $t('질병유형') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_5" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "다목적 체육관",

      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",

        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
